<template>
    <div>
        <ProductGrid :products="ProductData.slice(0,16)" :loading="isLoading" />
    </div>
</template>

<script setup>
import {computed, onMounted } from 'vue'
import { useProductStore } from '@/stores/useProductStore'
import ProductGrid from './product-grid.vue'

const productStore = useProductStore()

// Stable daily seed so the featured list doesn't reshuffle on every refresh.
// Remove or customize if you want fully random each time.
//const dailySeed = new Date().toISOString().slice(0, 10)

onMounted(() => {
  // Fetch 10 randomized "featured" products from the API
  productStore.loadStartPage();
})

// Keep your template compatible by exposing the store data as ProductData
const ProductData = computed(() => productStore.productData)
const isLoading = computed(() => productStore.isLoading)
</script>
